import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Confetti } from "@/components/Confetti";
import { Progress } from "@/components/ui/progress";
import { Award, Lock } from "lucide-react";

const KATEGORILER = ["Eylem", "Tematik", "Süreklilik"];

export default function Rozetler() {
  const [badges, setBadges] = useState([]);
  const [fire, setFire] = useState(false);

  useEffect(() => {
    api.get("/badges/me").then((r) => {
      setBadges(r.data);
      const earned = r.data.filter((b) => b.kazanildi).map((b) => b.kod);
      const prev = JSON.parse(localStorage.getItem("ao_badges") || "[]");
      const isNew = earned.some((k) => !prev.includes(k));
      if (isNew && prev.length >= 0) { setFire(true); setTimeout(() => setFire(false), 200); }
      localStorage.setItem("ao_badges", JSON.stringify(earned));
    });
  }, []);

  const total = badges.length;
  const earned = badges.filter((b) => b.kazanildi).length;

  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 py-8">
      <Confetti fire={fire} />
      <div className="fade-up">
        <p className="text-xs uppercase tracking-[0.2em] font-bold text-terra flex items-center gap-2"><Award size={14} /> Başarımlar</p>
        <h1 className="font-serif text-4xl sm:text-5xl text-ink tracking-tight mt-1">Rozet Kataloğu</h1>
        <p className="text-ink-2 mt-2">{earned} / {total} rozet kazanıldı.</p>
      </div>

      {KATEGORILER.map((kat) => (
        <section key={kat} className="mt-8">
          <h2 className="font-serif text-2xl text-ink mb-4">{kat} Rozetleri</h2>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {badges.filter((b) => b.kategori === kat).map((b) => (
              <div key={b.kod} data-testid={`badge-${b.kod}`}
                className={`border rounded-xl p-5 transition-all ${b.kazanildi ? "border-gold/40 bg-gold/5" : "border-line bg-surface opacity-70"}`}>
                <div className="flex items-center gap-3">
                  <div className={`w-12 h-12 rounded-full flex items-center justify-center text-2xl ${b.kazanildi ? "bg-gold/20" : "bg-surface-alt"}`}>
                    {b.kazanildi ? "🏅" : <Lock size={18} className="text-muted-foreground" />}
                  </div>
                  <div>
                    <h3 className="font-serif text-xl text-ink leading-tight">{b.ad}</h3>
                    <span className={`text-xs ${b.kazanildi ? "text-sage" : "text-muted-foreground"}`}>{b.kazanildi ? "🔓 Kazanıldı" : "Kilitli"}</span>
                  </div>
                </div>
                <p className="text-sm text-ink-2 mt-3">{b.aciklama}</p>
                {!b.kazanildi && (
                  <div className="mt-3">
                    <Progress value={b.yuzde} className="h-1.5 bg-surface-alt [&>div]:bg-terra" />
                    <p className="text-[11px] text-muted-foreground mt-1">İlerleme: {b.deger} / {b.hedef} (%{b.yuzde})</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </section>
      ))}
    </div>
  );
}
